<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--single-or-double">
    <div
      class="monitor_graph-box monitor_graph-box--single monitor_graph-box--scrollable">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <div class="monitor_dry-eye-questionnaire" tabindex="0">
        <div class="monitor_dry-eye-questionnaire_section">
          <div class="monitor_dry-eye-questionnaire_section_title">
            {{'monitor.dry-eye-questionnaire.sectionTitle1' | translate}}
          </div>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 1 }"></ng-container>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 2 }"></ng-container>
        </div>
        <div class="monitor_dry-eye-questionnaire_section">
          <div class="monitor_dry-eye-questionnaire_section_title">
            {{'monitor.dry-eye-questionnaire.sectionTitle2' | translate}}
          </div>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 3 }"></ng-container>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 4 }"></ng-container>
        </div>
        <div class="monitor_dry-eye-questionnaire_section">
          <div class="monitor_dry-eye-questionnaire_section_title">
            {{'monitor.dry-eye-questionnaire.sectionTitle3' | translate}}
          </div>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 5 }"></ng-container>
          <ng-container *ngTemplateOutlet="questionnaireResponseView; context: { questionNumber: 6 }"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="monitor_container-column">
    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      <app-percentage-circle
        id="test-percentage"
        class="monitor_circle-box"
        [percentage]="getPercentageDone()">
      </app-percentage-circle>
    </div>
  </div>

  <ng-template #questionnaireResponseView let-questionNumber="questionNumber">
    <div class="monitor_dry-eye-questionnaire_section_question-container">
      <div>
        {{ questionNumber }}. {{ 'monitor.dry-eye-questionnaire.question' + questionNumber | translate }}
      </div>
      @if (answers.length === 6 && [0, 1, 2, 3, 4].includes(answers[questionNumber - 1])) {
        <div>
          {{ 'monitor.dry-eye-questionnaire.answer' + answers[questionNumber - 1] | translate }}
        </div>
      } @else {
        <div>
        </div>
      }
    </div>
  </ng-template>

</app-monitor-layout>